import { gaEventNoHit } from "../../shared/helpers/gtm_tracking";

import { handleSubmit, addInvalidSubmitHandler } from "../../utils/Enquiries";
import initForm from "../../utils/Forms";

const trackAndRedirect = enquiry => () => {
  gaEventNoHit("The Masters Experience", "CTA", "Brochure");
  window.location = enquiry.dataset.redirect || "/";
};

const appendEmailMarketingStatement = () => {
  const { EMAIL_MARKETING_STATEMENT } = window;

  if (EMAIL_MARKETING_STATEMENT) {
    document
      .querySelectorAll(".js-email-marketing-statement")
      .forEach(container => {
        container.innerHTML += EMAIL_MARKETING_STATEMENT;
      });
  }
};

const initMastersExperienceEnquiry = () => {
  const enquiry = document.querySelector("#js-masters-experience-enquiry");

  if (enquiry) {
    const form = enquiry.querySelector(".js-enquiry-form");

    if (form) {
      initForm(form, {
        submit: handleSubmit(enquiry, { done: trackAndRedirect(enquiry) })
      });

      appendEmailMarketingStatement();
    }

    addInvalidSubmitHandler(form);
  }
};

export default initMastersExperienceEnquiry;



// WEBPACK FOOTER //
// ./components/enquiries/masters_experience_enquiry.js